import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import defaultProductImage from '../images/default-product.png';
import './ProductCategoriesSection.css';

const ProductCategoriesSection = () => {
    const { data: categories, loading, error } = useSelector(state => state.categories.top);

    return (
        <section className="product-categories-section py-5">
            <Container>
                {/* Заголовок секции */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h2 className="section-title">Категории продукции</h2>
                    </Col>
                </Row>
                
                {loading ? <LoadingSpinner message="Загрузка информации о категориях продукции..."/> :
                    <>
                        {/* Карточки категорий */}
                        <Row>
                            {categories && categories.map(category => (
                                <Col key={category.id} lg={3} md={6} sm={6} xs={12} className="mb-4">
                                    <Link to={`/catalog/${category.name}`} className="text-decoration-none">
                                        <Card className="category-card h-100 border-0 cursor-pointer">
                                            <div className="image-container">
                                                <Card.Img 
                                                    variant="top" 
                                                    src={category.image || defaultProductImage} 
                                                    alt={category.title}
                                                    className="category-image"
                                                    onError={(e) => {
                                                        e.target.onerror = null; // Предотвращает зацикливание
                                                        e.target.src = defaultProductImage;
                                                    }}
                                                />
                                            </div>
                                            <Card.Body className="text-center">
                                                <Card.Title className="category-title">{category.title}</Card.Title>
                                                <Card.Text className="category-description">
                                                    {category.description}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </Col>
                            ))}
                        </Row>

                        {/* Кнопка "Посмотреть все категории" */}
                        <Row className="mt-4">
                            <Col className="text-center">
                                <Link to="/catalog">
                                    <Button 
                                        variant="warning" 
                                        className="text-white rounded-pill px-4 py-2"
                                    >
                                        Посмотреть все категории
                                    </Button>
                                </Link>
                            </Col>
                        </Row>
                    </>
                }
            </Container>
        </section>
    );
};

export default ProductCategoriesSection;